// Lighter expresses integrator fees in value/1e6 units: the fraction charged
// is `units / 1_000_000`, so 100 units = 0.01% = 1 bp and 1000 units = 0.1%
// (Lighter's global perps cap). Displaying the raw unit count in a consent
// dialog would be meaningless to a trader, and getting the factor wrong by
// 100x — a mistake Lighter's own docs summary makes — would understate or
// overstate what the customer is authorizing.
export function formatIntegratorFeePercent(maxFeeUnits: number): string {
  if (!Number.isFinite(maxFeeUnits) || maxFeeUnits <= 0) return '0%'
  const percent = (maxFeeUnits / 1_000_000) * 100
  // Trim trailing zeros so 100 units reads "0.01%", not "0.010000%".
  return `${Number(percent.toFixed(6))}%`
}
